import http from "../../../utils/services/http-client";

class BookmarkService {
  getBookmarkList() {
    return http.get(`/Bookmarks`);
  }

}

export default new BookmarkService();
